import { Box, Typography } from "@mui/material";
import { toToman, toUnSignedToman } from "../../utils/Utils";
import { useTheme } from "@emotion/react";
import GrowthBadge from "../shared/GrowthBadge";

function PortfolioItemCard({ sx = [], ...props }) {
  const { portfolioItem } = props;

  return (
    <Box
      sx={{
        py: "8px",
        display: "flex",
        flexDirection: "column",
        borderBottom: (theme) => `1px solid ${theme.palette.grey[5]}`,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h5" color="grey.2">
          {portfolioItem.name}
        </Typography>
        <GrowthBadge rate={portfolioItem.efficiency} />
      </Box>
      <Box
        sx={{
          mt: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="subtitle1"
          color="grey.4"
        >{`تعداد: ${portfolioItem.unit} واحد`}</Typography>
        <Typography variant="subtitle1" color="grey.4">{`${toToman(
          portfolioItem.amount
        )} تومان`}</Typography>
        <Typography
          variant="subtitle1"
          color={portfolioItem.profit < 0 ? "red.main" : "primary.main"}
        >{`${toUnSignedToman(portfolioItem.profit)} تومان`}</Typography>
      </Box>
    </Box>
  );
}

export default PortfolioItemCard;
